import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import { sanitizeYaml } from "../../utilities"
import linkifyHtml from "linkify-html"

export default class Picture extends Component {
  render() {
    const { text, src } = this.props

    return (
      <div
        style={{
          width: "calc(100% - 64px)",
          height: "calc(100% - 64px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {text && (
          <div
            style={{
              textAlign: "center",
              textTransform: "none",
              padding: "32px 48px",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, .8)",
              backdropFilter: "blur(16px)",
              maxWidth: "min(960px, calc(100% - 96px))",
              marginBottom: "32px",
            }}
          >
            <Typography
              variant="h2"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(sanitizeYaml(text), {
                  target: "_blank",
                  attributes: {
                    class: "underlineOnHover",
                  },
                }),
              }}
            />
          </div>
        )}
        <img
          alt=""
          src={src}
          style={{
            opacity: src ? 1 : 0,
            width: "100%",
            height: text ? "calc(100% - 168px)" : "100%",
            objectFit: "contain",
          }}
        />
      </div>
    )
  }
}
